import { Injectable } from '@angular/core';
import {ApiService} from './Services/Api/api.service';
import {SessionService} from './Services/Session/session-service.service';
interface MyData {
  success: boolean;
  message: string;
}
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private  simpleLoggedStatus = false;
  private  otpStatus = false;
  private registerStatus = false;
  constructor(private session: SessionService) { }
  setRegisterIn(value: boolean) {
    this.registerStatus = value;
    this.session.saveParam('register', value.toString());
  }
  setOtpIn(value: boolean) {
    this.otpStatus = value;
    this.session.saveParam('otp', value.toString());
  }
  setSimpleLogged(value: boolean) {
    this.simpleLoggedStatus = value;
    this.session.saveParam('logged', value.toString());
  }
  get isLoggedIn() {
    return JSON.parse(this.session.getParam('logged') || 'false');
  }
  get isOtpIn() {
    return JSON.parse(this.session.getParam('otp') || 'false');
  }
  get isRegisterIn() {
    return JSON.parse(this.session.getParam('register') || 'false');
  }
}
